<template>
  <div class="agent-container">
    <div class="bg-content"></div>
    <Header />
    <AnAgentDetails />
    <Footer />
  </div>
</template>

<script>
  import Header from '../components/common/Header'
  import AnAgentDetails from '../components/AnAgent/AnAgentDetails'
  import Footer from '../components/common/Footer'

  export default {
    name: 'BecomeAnAgent',
    metaInfo: {
      title: 'Become An Agent',
    },
    components: {
      Header,
      AnAgentDetails,
      Footer
    },
  }
</script>

<style scoped>
.bg-content {
  margin: 0;
  position: absolute;
  top: 0;
  left: -1%;
  width: 102%;
  height: 100%;
  color: #fff;
  background-size: cover !important;
  background-image: url('../assets/k0RSXoBZux.png') !important;
  z-index: 0;
}
nav {
  background: rgba(236,229,234, 0.8);
  margin: 0 -50px;
  padding: 0 50px !important;
}
.navbar-nav, .search-input {
  background-color: transparent;
}
footer.content {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: transparent !important;
}
.agent-container {
  z-index: 1;
}
</style>